// Containers
import Full from '../containers/Full';
import Empty from '../containers/Empty';

// Views
import Dashboard from './views/Dashboard';

const Company  = () => import('./views/Company');
const Stores  = () => import('./views/Stores');
const Store  = () => import('./views/Store');
const Poss  = () => import('./views/Poss');
const Pos  = () => import('./views/Pos');
const CashFlow  = () => import('./views/CashFlow');
const PriceList  = () => import('./views/PriceList');
const Catalog  = () => import("./views/Catalog");
const CatalogCategory  = () => import("./views/CatalogCategory");
const CatalogCategoryProduct  = () => import("./views/CatalogCategoryProduct");
const Documents  = () => import('./views/Documents');
const CashFlowDetail  = () => import('./views/CashFlowDetail');
const Devices  = () => import('./views/Devices');
const Settings  = () => import('./views/Settings');
const PosSettings  = () => import('./views/PosSettings');
const PaymentSettings  = () => import('./views/PaymentSettings');
const VatSettings  = () => import('./views/VatSettings');
const VirtualPrintersSettings  = () => import('./views/VirtualPrintersSettings');
const PaymentSettingsDetail  = () => import('./views/PaymentSettingsDetail');
const OperatorSettings  = () => import('./views/OperatorSettings');
const OperatorSettingsDetail  = () => import('./views/OperatorSettingsDetail');
const Document  = () => import("./views/Document");
const Closures  = () => import("./views/Closures");
const Closure  = () => import("./views/Closure");
const CatalogVariant  = () => import("./views/CatalogVariant");
const ImportPosData  = () => import("./views/ImportPosData");
const Services  = () => import("./views/Services");
const AddonCgnTransactions  = () => import("./views/addons/cgn/AddonCgnTransactions");
const AddonCgnAuthorizations  = () => import("./views/addons/cgn/AddonCgnAuthorizations");
const AddonCgnInstall  = () => import("./views/addons/cgn/AddonCgnInstall");
const AddonCgnConfig  = () => import("./views/addons/cgn/AddonCgnConfig");
const Guest  = () => import("./views/Guest");
const Guests  = () => import("./views/Guests");
const GuestEdit  = () => import("./views/GuestEdit");
const VatEdit  = () => import("./views/VatEdit");
const PrintStatistics  = () => import("./views/PrintStatistics");
const PrintStatisticsCategory  = () => import("./views/PrintStatisticsCategory");
const DocInvoiceEdit  = () => import("./views/documents/DocInvoiceEdit");
const DocInvoice  = () => import("./views/documents/DocInvoice");
const DocumentMarkCashed  = () => import("./views/DocumentMarkCashed");
const DocumentIssueInvoice  = () => import("./views/DocumentIssueInvoice");
const EInvoiceActivation  = () => import("./views/e_invoice_service/EInvoiceActivation");
const EInvoiceFea  = () => import("./views/e_invoice_service/EInvoiceFea");
const EInvoiceServiceRecharges  = () => import("./views/e_invoice_service/EInvoiceServiceRecharges");
const EInvoiceServiceContracts  = () => import("./views/e_invoice_service/EInvoiceServiceContracts");
const EInvoiceFeaConfirm  = () => import("./views/e_invoice_service/EInvoiceFeaConfirm");
const DocPassiveInvoice  = () => import("./views/documents/DocPassiveInvoice");
const EInvoiceServiceRechargesUsage  = () => import("./views/e_invoice_service/EInvoiceServiceRechargesUsage");
const FreePremiumTrial  = () => import("./views/licenses/FreePremiumTrial");
const PosSeatsAssignment  = () => import("./views/licenses/PosSeatsAssignment");
const Proformas  = () => import("./views/Proformas");
const ServiceDocumentsSign  = () =>  import("./views/service_documents/ServiceDocumentsSign");
const SignedDocumentsList  = () =>  import("./views/service_documents/SignedDocumentsList");
const Wizard  = () =>  import("./views/Wizard");
const Registration  = () =>  import("./views/Registration");

const routes = (lang) => [
    {
        path: `/${lang}/customer/free-trial`,
        name: 'FreePremiumTrial',
        component: FreePremiumTrial
    },
    {
        path: `/${lang}/customer/service-documents/sign`,
        name: 'ServiceDocumentsSign',
        component: ServiceDocumentsSign
    },
    {
        path: `/${lang}/customer/wizard`,
        name: 'Wizard',
        component: Wizard
    },
    {
    path: `/${lang}/customer`,
    redirect: { name: 'Dashboard' },
    name: 'Home',
    meta: { label: 'Home', icon: null },
    component: Full,
    children: [
        {
            path: `registration`,
            name: 'Registration',
            meta: { label: 'Register organization', icon: null },
            component: Registration,
            alias: ['register', 'register/details']
        },
        {
            path: 'dashboard',
            name: 'Dashboard',
            meta: { label: 'Dashboard', icon: null },
            component: Dashboard
        },
        {
            path: 'company',
            name: 'Company Data',
            meta: { label: 'Company Data', icon: null },
            component: Company
        },
        {
            path: 'stores',
            name: 'StoresContainer',
            meta: { label: 'Stores', icon: null },
            redirect: { name: 'Stores' },
            component: Empty,
            children: [
                {
                    path: '',
                    name: 'Stores',
                    component: Stores,
                },
                {
                  path: ':store_id?',
                  name: 'StoreContainer',
                  meta: { label: 'Store', icon: null},
                  redirect: { name: 'Store' },
                  component: Empty,
                  children: [
                    {
                      path: '',
                      name: 'Store',
                      component: Store,
                      meta: { previous: 'Stores' }
                    }
                  ]
                },
            ]
        },
        {
            path: 'services',
            name: 'ServicesContainer',
            meta: { label: 'Services', icon: null },
            redirect: { name: 'Services' },
            component: Empty,
            children: [
                {
                    path: '',
                    name: 'Services',
                    component: Services,
                    meta: {
                        previous: 'Home',
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['mkt_unknown']
                    },
                },
                {
                    path: 'signed-documents-list',
                    name: 'SignedDocumentsList',
                    component: SignedDocumentsList,
                    meta: {
                        label: 'RCH XStore',
                        previous: 'Services',
                        allowedFor: ['mkt_it'],
                        hiddenFor: ['mkt_unknown']
                    },
                },
              {
                path: 'cgn',
                name: 'AddonsCgnContainer',
                meta: { label: 'CGN', icon: null,
                  allowedFor: ['mkt_it'],
                  hiddenFor: ['mkt_unknown']
                },
                redirect: { name: 'AddonCgn' },
                component: Empty,
                children: [
                  {
                    path: 'transactions',
                    name: 'AddonCgnTransactions',
                    meta: { label: 'Transactions', previous: 'Services',
                      allowedFor: ['mkt_it'],
                      hiddenFor: ['mkt_unknown']
                    },
                    component: AddonCgnTransactions,
                  },
                  {
                    path: 'authorizations',
                    name: 'AddonCgnAuthorizations',
                    meta: { label: 'Authorizations', previous: 'Services',
                      allowedFor: ['mkt_it'],
                      hiddenFor: ['mkt_unknown']
                    },
                    component: AddonCgnAuthorizations,
                  },
                  {
                    path: 'authorizations/:authorization/config',
                    name: 'AddonCgnConfig',
                    meta: { label: 'Config', icon: null, previous: 'AddonCgnAuthorizations',
                      allowedFor: ['mkt_it'],
                      hiddenFor: ['mkt_unknown']
                    },
                    component: AddonCgnConfig,
                  },
                  {
                    path: 'install',
                    name: 'AddonCgnInstall',
                    meta: { label: 'Install', icon: null, previous: 'AddonCgnTransactions',
                      allowedFor: ['mkt_it'],
                      hiddenFor: ['mkt_unknown']
                    },
                    component: AddonCgnInstall,
                  },
                ]
              },
            ]
        },
        {
            path: 'pos',
            name: 'POSContainer',
            meta: { label: 'POS', icon: null },
            redirect: { name: 'POS ' },
            component: Empty,
            children: [
                {
                    path: '',
                    name: 'POS ',
                    component: Poss,
                },
                {
                    path: 'assign-seats',
                    name: 'POS ',
                    component: PosSeatsAssignment,
                },
                {
                    path: ':pos_id?',
                    name: 'POS',
                    meta: { label: 'Pos', icon: null, previous: 'POS ' },
                    component: Pos,
                },
            ]
        },
        {
            path: 'cashflow',
            name: 'CashFlowContainer',
            meta: {
              label: 'Cashflows',
              icon: null,
              allowedFor: ['mkt_it'],
              hiddenFor: ['mkt_unknown']
            },
            redirect: { name: 'CashFlow' },
            component: Empty,
            children: [
                {
                    path: '',
                    name: 'CashFlow',
                    props: true,
                    component: CashFlow,
                    meta: {
                      allowedFor: ['mkt_it'],
                      hiddenFor: ['mkt_unknown'],
                      disabledForLicenseCode: ['personal']
                    },
                },
                {
                    path: ':cashflow_id?',
                    name: 'CashFlowDetail',
                    meta: {
                      label: 'Detail',
                      icon: null,
                      previous: 'CashFlow',
                      allowedFor: ['mkt_it'],
                      hiddenFor: ['mkt_unknown'],
                      disabledForLicenseCode: ['personal']
                    },
                    component: CashFlowDetail
                },
            ]
        },
        {
            path: 'devices/:installation_id?',
            name: 'Devices',
            meta: { label: 'Devices', icon: null,
                allowedFor: ['mkt_it'],
                hiddenFor: ['mkt_unknown']
            },
            component: Devices,
            props: true
        },
        {
            path: 'invoices',
            name: 'InvoicesContainer',
            redirect: { name: 'Invoices' },
            component: Empty,
            children: [
                {
                    path: ':document_id?',
                    name: 'InvoiceContainer',
                    meta: { },
                    redirect: { name: 'Invoice' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Invoice',
                            props: true,
                            component: DocInvoice,
                            meta: { label: 'Document Details', previous: 'Documents' },
                        },
                        {
                            path: 'edit',
                            name: 'InvoiceEdit',
                            meta: { label: 'Edit', icon: null, previous: 'Invoice' },
                            props: true,
                            component: DocInvoiceEdit
                        },
                    ]
                },
            ]
        },
        {
            path: 'passive-invoices',
            name: 'PassiveInvoicesContainer',
            redirect: { name: 'PassiveInvoices' },
            component: Empty,
            children: [
                {
                    path: ':invoice_id?',
                    name: 'PassiveInvoiceContainer',
                    meta: { },
                    redirect: { name: 'PassiveInvoice' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'PassiveInvoice',
                            props: true,
                            component: DocPassiveInvoice,
                            meta: { label: 'Document Details', previous: 'Documents' },
                        },
                    ]
                },
            ]
        },
        {
            path: 'pos-settings',
            name: 'Pos Settings Container',
            meta: {
            label: 'Pos settings',
            icon: null},
            component: Empty,
            children: [
                {
                    path: '',
                    name: 'Pos Settings',
                    meta: { label: 'Pos settings', icon: null, allowedFor: ['feat_provisioning'] },
                    component: PosSettings,
                },
                {
                    path: 'payments',
                    name: 'Payment Settings',
                    meta: { label: 'Payment settings', icon: null, previous: 'Pos Settings', allowedFor: ['feat_provisioning'] },
                    props: true,
                    component: PaymentSettings
                },
                {
                    path: 'payments/:payment_id?',
                    name: 'Payment Settings Details',
                    meta: { label: 'Payment details', icon: null, previous: 'Payment Settings', allowedFor: ['feat_provisioning'] },
                    props: true,
                    component: PaymentSettingsDetail
                },
                {
                    path: 'vats',
                    name: 'Vat Settings',
                    meta: { label: 'VAT Groups settings', icon: null, previous: 'Pos Settings', allowedFor: ['feat_provisioning'] },
                    props: true,
                    component: VatSettings
                },
                // {
                //     path: 'production_units',
                //     name: 'Production Units Settings',
                //     meta: { label: 'Production units', icon: null, previous: 'Pos Settings', allowedFor: ['feat_provisioning'] },
                //     props: true,
                //     component: ProductionUnitsSettings
                // },
                // {
                //     path: 'production_units/:production_unit_id?',
                //     name: 'Production Units Settings Details',
                //     meta: { label: 'Production units details', icon: null, previous: 'Production Units Settings', allowedFor: ['feat_provisioning'] },
                //     props: true,
                //     component: ProductionUnitsSettingsDetail
                // },
                {
                    path: 'operators',
                    name: 'Operator Settings',
                    meta: { label: 'Operators', icon: null, previous: 'Pos Settings', allowedFor: ['feat_provisioning'] },
                    props: true,
                    component: OperatorSettings
                },
                {
                    path: 'operators/:operator_id?',
                    name: 'Operator Settings Details',
                    meta: { label: 'Operator settings details', icon: null, previous: 'Operator Settings', allowedFor: ['feat_provisioning'] },
                    props: true,
                    component: OperatorSettingsDetail
                },

                {
                    path: 'printers',
                    name: 'Printers Settings',
                    meta: { label: 'Printers', icon: null, previous: 'Pos Settings', allowedFor: ['feat_provisioning'] },
                    props: true,
                    component: VirtualPrintersSettings
                },
            ]
        },
        {
            path: 'settings',
            name: 'SettingsContainer',
            meta: {
            label: 'Settings',
            icon: null,
            allowedFor: ['mkt_it'],
            hiddenFor: ['mkt_unknown']},
            redirect: { name: 'Settings' },
            component: Empty,
            children: [
                {
                    path: '',
                    name: 'Settings',
                    component: Settings,
                    meta: {
                      allowedFor: ['mkt_it'],
                      hiddenFor: ['mkt_unknown']
                    }
                },
                {
                    path: 'import',
                    name: 'SettingsImportPosData',
                    meta: { label: 'Import', icon: null, previous: 'Settings' },
                    props: true,
                    component: ImportPosData
                },
                {
                    path: 'vats/:vat_id',
                    name: 'VatEdit',
                    meta: { label: 'Edit Vat', icon: null, previous: 'Settings' },
                    props: true,
                    component: VatEdit
                },
            ]
        },
        {
            path: 'price-list',
            name: 'PricelistContainer',
            component: Empty,
            redirect: { name: 'Catalogs' },
            children: [
                {
                    path: 'catalogs',
                    name: 'ListCatalogContainer',
                    redirect: { name: 'Catalogs' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Catalogs',
                            component: PriceList,
                            meta: { label: 'Catalogs', previous: 'Home', icon: null, allowedFor: ['feat_provisioning']},
                            props: {
                                'activeTab': 0
                            }
                        },
                        {
                            path: ':catalog_id/products',
                            name: 'Catalog',
                            meta: { label: 'Catalog details', icon: null, previous: 'Catalogs', allowedFor: ['feat_provisioning']  },
                            props: {
                                'activeTab': 1
                            },
                            component: Catalog
                        },
                        {
                            path: ':catalog_id/categories',
                            name: 'CatalogCategories',
                            meta: { label: 'Catalog details', icon: null, previous: 'Catalogs', allowedFor: ['feat_provisioning']  },
                            props: {
                                'activeTab': 0
                            },
                            component: Catalog
                        },
                        {
                            path: ':catalog_id/variants',
                            name: 'CatalogVariants',
                            meta: { label: 'Catalog details', icon: null, previous: 'Catalogs', allowedFor: ['feat_provisioning']  },
                            props: {
                                'activeTab': 2
                            },
                            component: Catalog
                        },
                        {
                            path: ':catalog_id/category/:category_id?',
                            name: 'CatalogCategoryFromCatalog',
                            meta: { label: 'Category details', icon: null, previous: 'CatalogCategories', allowedFor: ['feat_provisioning']  },
                            props: {
                                'scope': "catalog"
                            },
                            component: CatalogCategory
                        },
                        {
                            path: ':catalog_id/category/:category_id/variant/:variant_id',
                            name: 'CatalogCategoryVariantFromCatalog',
                            meta: { label: 'Category details', icon: null, previous: 'CatalogCategoryFromCatalog', allowedFor: ['feat_provisioning']  },
                            props: {
                                'scope': "catalogCategory"
                            },
                            component: CatalogVariant
                        },
                        {
                            path: ':catalog_id/category/:category_id/product/:product_id?',
                            name: 'CatalogCategoryProductFromCatalog',
                            meta: { label: 'Product details', icon: null, previous: 'CatalogCategoryFromCatalog', allowedFor: ['feat_provisioning']  },
                            props: {
                                'scope': "catalogCategory"
                            },
                            component: CatalogCategoryProduct
                        },
                        {
                            path: ':catalog_id/category/:category_id/product/:product_id/variant/:variant_id',
                            name: 'CatalogCategoryProductVariantFromCatalog',
                            meta: { label: 'Variant specifications', icon: null, previous: 'CatalogCategoryProductFromCatalog', allowedFor: ['feat_provisioning']  },
                            props: {
                                'scope': "catalogProduct",
                                'switchEnabled': false,
                            },
                            component: CatalogVariant
                        },
                        {
                            path: ':catalog_id/variant/:variant_id',
                            name: 'CatalogVariantFromCatalog',
                            meta: { label: 'Variant specifications', icon: null, previous: 'Catalog', allowedFor: ['feat_provisioning']  },
                            props: true,
                            component: CatalogVariant
                        },
                    ]
                },
                {
                    path: 'categories',
                    name: 'ListCategoriesContainer',
                    redirect: { name: 'Categories' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Categories',
                            component: PriceList,
                            meta: { label: 'Categories', previous: 'Home', icon: null, allowedFor: ['feat_provisioning']},
                            props: {
                                'activeTab': 1
                            }
                        },
                        {
                            path: ':category_id/catalog/:catalog_id?',
                            name: 'CatalogCategoryFromList',
                            meta: { label: 'Category specifications', icon: null, previous: 'Categories', allowedFor: ['feat_provisioning']  },
                            props: {
                                'scope': "category"
                            },
                            component: CatalogCategory
                        },
                        {
                            path: ':category_id/catalog/:catalog_id/product/:product_id?',
                            name: 'CatalogCategoryProductFromCategory',
                            meta: { label: 'Product details', icon: null, previous: 'CatalogCategoryFromList', allowedFor: ['feat_provisioning']  },
                            props: {
                                'scope': "category"
                            },
                            component: CatalogCategoryProduct
                        },
                        {
                            path: ':category_id/catalog/:catalog_id/variant/:variant_id',
                            name: 'CatalogCategoryVariantFromCategory',
                            meta: { label: 'Variant specifications', icon: null, previous: 'CatalogCategoryFromList', allowedFor: ['feat_provisioning']  },
                            props: {
                                'scope': "category"
                            },
                            component: CatalogVariant
                        },
                    ]
                },
                {
                    path: 'products',
                    name: 'ListProductsContainer',
                    redirect: { name: 'Products' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Products',
                            component: PriceList,
                            meta: { label: 'Products', previous: 'Home', icon: null, allowedFor: ['feat_provisioning']},
                            props: {
                                'activeTab': 2
                            }
                        },
                        {
                            path: ':product_id/catalog/:catalog_id?/category/:category_id?',
                            name: 'CatalogCategoryProductFromList',
                            meta: { label: 'Product specifications', icon: null, previous: 'Products', allowedFor: ['feat_provisioning']  },
                            props: {
                                'scope': "product"
                            },
                            component: CatalogCategoryProduct
                        },
                        {
                            path: ':product_id/catalog/:catalog_id/category/:category_id?/variant/:variant_id',
                            name: 'CatalogCategoryProductVariantFromList',
                            meta: { label: 'Variant specifications', icon: null, previous: 'CatalogCategoryProductFromList', allowedFor: ['feat_provisioning']  },
                            props: {
                                'scope': "product",
                                'switchEnabled': false,
                            },
                            component: CatalogVariant
                        },
                    ]
                },
                {
                    path: 'variants',
                    name: 'ListVariantsContainer',
                    redirect: { name: 'Variants' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Variants',
                            component: PriceList,
                            meta: { label: 'Variants', previous: 'Home', icon: null, allowedFor: ['feat_provisioning']},
                            props: {
                                'activeTab': 3
                            }
                        },
                        {
                            path: ':variant_id/catalog/:catalog_id?',
                            name: 'CatalogVariantFromList',
                            meta: { label: 'Variant specifications', icon: null, previous: 'Variants', allowedFor: ['feat_provisioning']  },
                            props: {
                                'scope': "variant"
                            },
                            component: CatalogVariant
                        },
                    ]
                },
            ]
        },
        {
            path: 'sales',
            name: 'SalesContainer',
            redirect: { name: 'Documents' },
            component: Empty,
            children: [
                {
                    path: 'documents',
                    name: 'DocumentsContainer',
                    meta: { label: 'Invoices and Documents', icon: null },
                    redirect: { name: 'Documents' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Documents',
                            meta: { label: 'Invoices and Documents', icon: null },
                            props: true,
                            component: Documents
                        },
                        {
                            path: ':document_id?',
                            name: 'Document',
                            meta: { label: 'Document Details', icon: null, previous: 'Documents' },
                            props: true,
                            component: Document
                        },
                        {
                            path: 'mark-cashed/preview',
                            name: 'DocumentMarkCashed',
                            meta: { label: 'Mark as cashed', icon: null, previous: 'Documents',
                                allowedFor: ['e_invoice']
                            },
                            props: true,
                            component: DocumentMarkCashed
                        },
                        {
                            path: 'issue-invoice/preview',
                            name: 'DocumentIssueInvoice',
                            meta: { label: 'Issue invoice', icon: null, previous: 'Documents',
                              allowedFor: ['e_invoice']
                            },
                            props: true,
                            component: DocumentIssueInvoice
                        },
                    ]
                },
                {
                    path: 'proforma',
                    name: 'ProformasContainer',
                    meta: {
                      label: 'Proformas',
                      icon: null,
                      allowedFor: ['mkt_it'],
                      hiddenFor: ['mkt_unknown']
                    },
                    redirect: { name: 'Proformas' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Proformas',
                            meta: { label: 'Proformas', icon: null },
                            props: true,
                            component: Proformas
                        },
                        {
                            path: ':document_id?',
                            name: 'ProformaDocument',
                            meta: { label: 'Document Details', icon: null, previous: 'Proformas' },
                            props: true,
                            component: Document
                        },
                    ]
                },
                {
                    path: 'closures',
                    name: 'ClosuresContainer',
                    meta: { label: 'Closures', icon: null },
                    redirect: { name: 'Closures' },
                    component: Empty,
                    children: [
                        {
                            path: '',
                            name: 'Closures',
                            props: true,
                            component: Closures
                        },
                        {
                            path: ':closure_id?',
                            name: 'Closure',
                            meta: { label: 'Closure', icon: null, previous: 'Closures' },
                            props: true,
                            component: Closure
                        },
                    ]
                },
            ]
        },
        {
          path: 'guests',
          name: 'GuestsContainer',
          meta: {
              label: 'Guests',
              icon: null,
              allowedFor: ['mkt_it', 'mkt_de', 'with_guests'],
              hiddenFor: ['mkt_unknown'],
          },
          redirect: { name: 'Guests' },
          component: Empty,
          children: [
            {
              path: '',
              name: 'Guests',
              props: true,
              component: Guests
            },
            {
              path: 'new',
              name: 'GuestNew',
              meta: { label: 'New', icon: null, previous: "Guests" },
              props: true,
              component: GuestEdit
            },
            {
              path: ':guest_id',
              name: 'GuestContainer',
              meta: { label: 'Guest', icon: null },
              redirect: { name: 'Guest' },
              component: Empty,
              children: [
                {
                  path: '',
                  name: 'Guest',
                  props: true,
                  component: Guest,
                  meta: { previous: "Guests" },
                },
                {
                  path: 'edit',
                  name: 'GuestEdit',
                  meta: { label: 'Edit', icon: null, previous: "Guest" },
                  props: true,
                  component: GuestEdit
                },
              ]
            },
          ]
        },
        {
          path: 'maintenance',
          name: 'Maintenance',
          redirect: { name: 'Home' },
        },
        {
          path: 'print-statistics',
          name: 'PrintStatistics',
          meta: { label: 'PrintStatistics', icon: null, disabledForLicenseCode: ['personal'] },
          component: PrintStatistics
        },
        {
          path: 'print-statistics',
          name: 'PrintStatisticsContainer',
          meta: { label: 'PrintStatistics', icon: null, disabledForLicenseCode: ['personal'] },
          redirect: { name: 'PrintStatistics' },
          component: Empty,
          children: [
            {
              path: '',
              name: 'PrintStatistics',
              props: true,
              component: PrintStatistics
            },
            {
              path: 'category',
              name: 'PrintStatisticsCategory',
              meta: { label: 'PrintStatisticsCategory', icon: null, previous: 'PrintStatistics', disabledForLicenseCode: ['personal'] },
              props: true,
              component: PrintStatisticsCategory
            },
          ]
        },
        {
          path: 'e-invoice',
          name: 'EInvoiceContainer',
          meta: {
            label: '', icon: null,
            allowedFor: ['e_invoice']
          },
          redirect: {name: 'Dashboard'},
          component: Empty,
          children: [
              {
                  path: 'fea',
                  name: 'EInvoiceFea',
                  meta: { label: 'EInvoiceFea', icon: null },
                  props: true,
                  component: EInvoiceFea
              },
              {
                  path: 'fea-confirm',
                  name: 'EInvoiceFeaConfirm',
                  meta: { label: 'Confirm', icon: null, previous: 'EInvoiceFea' },
                  props: true,
                  component: EInvoiceFeaConfirm
              },
              {
                  path: 'activation',
                  name: 'EInvoiceActivation',
                  meta: { label: 'EInvoiceActivation', icon: null, previous: 'Services' },
                  props: true,
                  component: EInvoiceActivation
              },
              {
                  path: 'top-ups',
                  name: 'GuestStoreContainer',
                  redirect: { name: 'EInvoiceServiceRecharges' },
                  component: Empty,
                  children: [
                      {
                          path: '',
                          name: 'EInvoiceServiceRecharges',
                          props: true,
                          component: EInvoiceServiceRecharges,
                          meta: { previous: "Services", label: 'Recharges', icon: null },
                      },
                      {
                          path: ':top_up_id?',
                          name: 'EInvoiceServiceRechargesUsage',
                          meta: { previous: "EInvoiceServiceRecharges", label: 'Recharge Details', icon: null },
                          props: true,
                          component: EInvoiceServiceRechargesUsage
                      },
                  ]
              },
              {
                  path: 'contracts',
                  name: 'EInvoiceServiceContracts',
                  meta: { label: 'Contracts', icon: null, previous: 'Services' },
                  props: true,
                  component: EInvoiceServiceContracts
              }
          ]
        },
        {
            // will match everything
            path: '*',
            redirect: { name: 'Dashboard' },
        },
    ]
}
];

export default routes;
